/**
 * This was implemented because the pds for ped needed to have a title while the rest have to have a alpha char at the end of the title
 * PED needs to be displayed at the end as well
 * @param {Immutable.List} productDisclosures Map of productDisclosures
 * @param {string} titleType where to display the full title or not
 * @returns {Immutable.List} PDS sorted info
 */
export const sortAndMutatePdsData = (productDisclosures, titleType) => productDisclosures
    .sortBy((pds) => pds.get('code') === 'pdsb')
    .sortBy((pds) => pds.get('code') === 'spds')
    .sortBy((pds) => pds.get('code') === 'PEG')
    .sortBy((pds) => pds.get('code') === 'ped')
    .map((pds, index) => {
        const newChar = String.fromCharCode(65 + index);
        const title = getTitle(pds, newChar, titleType, productDisclosures.size === 1);
        return pds.merge({
            key: `pds.${newChar}`,
            title
        });
    });

const getTitle = (pds, char, titleType, hasOneLink) => {
    const isStandardPDS = pds.get('code') === 'pdsa' || pds.get('code') === 'pdsb';
    if (hasOneLink && pds.get('code') === 'pdsa') {
        switch (titleType) {
            case 'part':
                return 'PDS';
            case 'min':
                return 'PDS';
            default:
                return 'Product disclosure';
        }
    }
    switch (titleType) {
        case 'part':
            return isStandardPDS ? `PART ${char}` : pds.get('code').toUpperCase();
        case 'min':
            return isStandardPDS ? `PDS ${char}` : pds.get('code').toUpperCase();
        default:
            if (pds.get('code') === 'PDS') return 'Product Disclosure Statement';
            if (pds.get('code') === 'PEG') return 'Premium and Excess Guide';
            return isStandardPDS ? `Product disclosure ${char}` : pds.get('title');
    }
};
